/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
* Author: 
*/

import type { SVGProps } from "react"

const PaymentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props} fill="none">
    <path 
      fillRule="evenodd"
      clipRule="evenodd"
      d='M13.5 13.5C12.6667 13.5 11.9583 13.2083 11.375 12.625C10.7917 12.0417 10.5 11.3333 10.5 10.5C10.5 9.66667 10.7917 8.95833 11.375 8.375C11.9583 7.79167 12.6667 7.5 13.5 7.5C14.3333 7.5 15.0417 7.79167 15.625 8.375C16.2083 8.95833 16.5 9.66667 16.5 10.5C16.5 11.3333 16.2083 12.0417 15.625 12.625C15.0417 13.2083 14.3333 13.5 13.5 13.5ZM5.5 17C5.0875 17 4.73438 16.8531 4.44062 16.5594C4.14687 16.2656 4 15.9125 4 15.5V5.5C4 5.0875 4.14687 4.73438 4.44062 4.44063C4.73438 4.14687 5.0875 4 5.5 4H21.5C21.9125 4 22.2656 4.14687 22.5594 4.44063C22.8531 4.73438 23 5.0875 23 5.5V15.5C23 15.9125 22.8531 16.2656 22.5594 16.5594C22.2656 16.8531 21.9125 17 21.5 17H5.5ZM8 15.5H19C19 14.8 19.2417 14.2083 19.725 13.725C20.2083 13.2417 20.8 13 21.5 13V8C20.8 8 20.2083 7.75833 19.725 7.275C19.2417 6.79167 19 6.2 19 5.5H8C8 6.2 7.75833 6.79167 7.275 7.275C6.79167 7.75833 6.2 8 5.5 8V13C6.2 13 6.79167 13.2417 7.275 13.725C7.75833 14.2083 8 14.8 8 15.5ZM20 19.25C20 19.6642 19.6642 20 19.25 20H2.5C2.0875 20 1.73438 19.8531 1.44063 19.5594C1.14687 19.2656 1 18.9125 1 18.5V7.75C1 7.33579 1.33579 7 1.75 7C2.16421 7 2.5 7.33579 2.5 7.75V17.5C2.5 18.0523 2.94772 18.5 3.5 18.5H19.25C19.6642 18.5 20 18.8358 20 19.25Z'
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

export default PaymentIcon
